import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { PipelineAction, PipelineField, PipelineStep, PipelineStage } from './';
import {Row, Col} from 'react-bootstrap';
import * as Actions from 'actions';

class Milestones extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { job, pipeline } = this.props;

    if(!job || !pipeline) {
      return <noscript />
    }
    let width = 100 / (pipeline.stages.length);
    let currentIndex = 0;
    pipeline.stages.forEach((stage, index) => {
      if(job.milestone == stage.name) {
        currentIndex = index;
      }
    });
    let progress_width = 100 - width;
    let progress = (100 / (pipeline.stages.length - 1)) * currentIndex;

    let currentMilestoneIndex = pipeline.stages.find(({name}) => name == job.milestone) ? true : false;
    return <div className="wizard-progress">
      <div className="steps-progress" style={{ width : `${progress_width}%`, margin : `0 ${width/2}%`}}>
        <div className="progress-indicator" style={{width: `${progress}%`}}></div>
      </div>
      <ul className="wizard-steps" style={{textAlign : 'justify'}}>
        {pipeline.stages.map((stage, index) =>
          <li
            key={index}
            className={`${currentIndex <= index ? currentIndex == index ? 'active' : '' : 'completed'}`}
            style={{width : `${width}%`, maxWidth : `none`}}
            >
            <a
              href="#"
              onClick={e => {
                e.preventDefault();
                this.props.selectStage(stage);
              }}
              >
              <span>{stage.name[0]}</span>{stage.name}
            </a>
          </li>
        )}
      </ul>
    </div>
  }
}

class Pipeline extends React.Component {
  constructor(props) {
    super(props);
    this.startOpportunity = this.startOpportunity.bind(this);
    this.cancelOpportunity = this.cancelOpportunity.bind(this);
    this.selectStage = this.selectStage.bind(this);
    this.verifyStage = this.verifyStage.bind(this);
  }
  selectStage(stage) {
    this.props.sendSocketEmit({
      job : {...this.props.job, milestone : stage.name},
    }, 'update-job-milestone');
  }
  startOpportunity() {
    this.props.sendSocketEmit({
      job : {...this.props.job, milestone : this.props.pipeline.stages[0].name}
    }, 'update-job-milestone');
  }
  cancelOpportunity() {
    this.props.sendSocketEmit({
      job : {...this.props.job, milestone : 'Cancelled'},
    }, 'update-job-milestone');
  }
  static propTypes = {
    pipeline : PropTypes.object,
    job : PropTypes.object,
    client : PropTypes.object,
  }
  verifyStage() {
    const { pipeline, job, client } = this.props;
    if(!pipeline || !job || job.milestone == 'Cancelled' || !client || !pipeline.stages[0]) {
      return;
    }
    let current_stage_index = pipeline.stages.findIndex(stage => stage.name == job.milestone);
    if(current_stage_index < 0) {
      this.selectStage(pipeline.stages[0]);
    }
  }
  componentDidUpdate() {
    this.verifyStage();
  }
  componentDidMount() {
    this.verifyStage();
  }
  render() {
    const { pipeline, job, client } = this.props;
    if(!job || !client) {
      return <div></div>
    }
    if(!pipeline || pipeline.stages.length == 0) {
      return (
        <div className="alert alert-info">
          <h3>Create your pipeline to use the sales's tool.</h3>
          <p>Set up your sales process to move your opportunity forward.</p>
          <hr className="dotted" />
          <Link to={'/clients/settings/pipeline-builder'} className="btn btn-info">Get Started!</Link>
        </div>
      );
    }
    let current_stage_index = pipeline.stages.findIndex(stage => stage.name == job.milestone);

    return <div>
      <Milestones pipeline={pipeline} job={job} selectStage={this.selectStage} />
      {pipeline.stages.map((stage, index) => <PipelineStage key={stage._id} job={job} client={client} stage={stage} />)}
      <hr />
        {job.milestone == 'Cancelled' ? (
        <Row>
          <Col xs={6} xsOffset={3}>
            <div
              onClick={e => this.startOpportunity()}
              className="btn btn-danger btn-block"
              >
              Re-open Opportunity</div>
          </Col>
        </Row>
        ) : (
          <div>
            <Row>
              {current_stage_index + 1 != pipeline.stages.length ? (
                <Col
                  xs={6}
                  md={4}
                  >
                  <div
                    onClick={this.cancelOpportunity}
                    className="btn btn-danger btn-block"><i className="fa fa-close"></i> Mark Closed & Lost
                  </div>
                </Col>
              ) : ''}
              {current_stage_index + 1 != pipeline.stages.length ? (
                <Col
                   xs={6}
                   md={4}
                   >
                   <div
                     onClick={e => this.selectStage(pipeline.stages[pipeline.stages.length - 1])}
                     className="btn btn-success btn-block"
                     >
                     <i className="fa fa-close"></i> Mark Closed & Won
                   </div>
                 </Col>
              ) : ''}
            </Row>
            <Row className="mt-sm">
              {current_stage_index > 0 ? (
                <Col xs={6} md={4}>
                  <div
                    onClick={e => this.selectStage(pipeline.stages[current_stage_index - 1])}
                    className="btn btn-default btn-block"
                    ><i className="fa fa-chevron-left"></i> Revert to {pipeline.stages[current_stage_index - 1].name}
                  </div>
                </Col>
              ) : ''}
              {current_stage_index + 1 != pipeline.stages.length ? (
                <Col
                  xs={6}
                  md={4}
                  mdOffset={4}
                  >
                  <div
                    onClick={e => this.selectStage(pipeline.stages[current_stage_index + 1])}
                    className="btn btn-default btn-block"
                    >
                    Convert to {pipeline.stages[current_stage_index + 1].name}
                    <i className="fa fa-chevron-right"></i>
                  </div>
                </Col>
              ) : ''}
            </Row>
          </div>
        )}
    </div>
  }
}

export default connect(f => ({}), Actions)(Pipeline);



// WEBPACK FOOTER //
// ./src/browser/components/pipeline/pipeline.js